export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const roundDigits = (value, digits) => {
  return Math.round((value * (10 ^ digits)) / (10 ^ digits));
};

export const isNumNaN = (value) => {
  return isNaN(value) ? 0 : value;
};

export const getYear = (num) => {
  const year = new Date().getFullYear();
  return String(year - num);
};

export function convertDecimalToHoursMinutes(decimalHours) {
  if (decimalHours === 0 || decimalHours === null) {
    return "-";
  }
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  const paddedHours = String(hours).padStart(2, "0");
  const paddedMinutes = String(minutes).padStart(2, "0");
  return `${paddedHours}:${paddedMinutes}`;
}

export function closeModal(id = "exampleModal") {
  const button = document.querySelector(`.${id}-modal-btn-close`);

  if (button instanceof HTMLElement) {
    button.click();
  }
}

export function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function extractObjectLabels(obj) {
  const a: string[] = [];
  obj.map((data: { value: number; label: string }) => a.push(data.label));
  return a.join(", ");
}

export function hexToRgba(hex, alpha = 0.3) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function fontColorBasedonBg(color) {
  //<--color in the way '#RRGGBB
  if (color.length == 7) {
    const rgb = [
      parseInt(color.substring(1, 3), 16),
      parseInt(color.substring(3, 5), 16),
      parseInt(color.substring(5), 16),
    ];
    const luminance =
      (0.2126 * rgb[0]) / 255 +
      (0.7152 * rgb[1]) / 255 +
      (0.0722 * rgb[2]) / 255;
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  }
  return "#000000"; //<--default color if not in the right format
}

export const setValueAsNumber = (v: string) => (v === "" ? "" : Number(v));
